<template>
  <a-row class="wrapper" type="flex" align="middle" justify="center">
    <a-col :xs="24" :md="14" :lg="6">
      <logo-svg class="logo" />
      <div class="box">
        <router-view />
      </div>
    </a-col>
  </a-row>
</template>

<script>
import LogoSvg from '@/assets/logo.svg'

export default {
  components: {
    LogoSvg
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100vh;
}

.box {
  border: 1px solid #eaeaea;
  border-radius: 12px;
  padding: 24px 24px 28px;
}

.logo {
  max-width: 300px;
  display: block;
  margin: 0 auto 16px;
}
</style>
